import React, { useEffect, useState } from "react"
import { useHistory, useParams } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import LeftMenu from "../../leftmenu"
import ContentEdit from "../../content/edit";
import LoadScreen from "../../loadScreen";
import apiCall from "../../api"
import t from "../../translate"

const PlatformQuestionnairesEdit = props => {

   const params = useParams()

   const options = ["quote", "list", "wysiwyg", "question_checkboxes", "question_radio", "question_open", "video", "image", "select", "special", "divider", "chart", "matrix", "slider", "form", "datepicker"]

   const [contentIndex, setContentIndex] = useState(0)
   const [content, setContent] = useState("")
   const [editable, setEditable] = useState(false)

   const auth = useSelector(state => state.auth)


   useEffect(() => {
      apiCall({
         action: 'get_platform_questionnaire',
         token: auth.token,
         data: {
            questionnaire_id: params.questionnaire_id
         }
      }).then(resp => {   
         resp.settings.newPart = false
         resp.settings.removePart = false
         setContent(resp.settings)
         setEditable(true)
      })
   }, [params.questionnaire_id])

   return (
      <>
         <LeftMenu />
         {
            editable ? 
               <ContentEdit
                  id={params.questionnaire_id}
                  options={options}
                  content={content}
                  contentIndex={contentIndex}
                  type="questionnaire"
                  linkName={t("Platform vragenlijsten")}
                  name={content.title}
                  saveAction="save_platform_questionnaire"
                  action={false}
                  url={"platformquestionnaires"}
               />
               :
               <LoadScreen />
         }
      </>
   )
}

export default PlatformQuestionnairesEdit